import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getEventsCount } from "../../../../../services/SystemLoggingService";

export function EventsCard() {
  const { id } = useParams<{ id: string }>();
  const [eventsCount, setEventsCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEventsCount = async () => {
      if (!id) return;

      try {
        setIsLoading(true);
        const count = await getEventsCount(id);
        setEventsCount(count);
      } catch (error) {
        console.error("Failed to fetch events count:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEventsCount();
  }, [id]);

  return (
    <div className="flex flex-col rounded-lg bg-white px-4 py-6 ring-1 ring-gray-250v2">
      <span className="font-inter text-left font-medium text-xs leading-4 tracking-[0.05em] uppercase text-gray-550">
        EVENTS
      </span>
      <div className="flex items-baseline gap-2">
        <span className="font-inter font-medium text-2xl leading-9 text-gray-900">
          {isLoading ? "..." : eventsCount}
        </span>
        <span className="font-inter font-medium text-sm leading-5 text-gray-550">
          last 30 days
        </span>
      </div>
    </div>
  );
}
